var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SecondaryHeadingContent } from "../../SecondaryHeadingContent";
import { SecondaryHeading } from "../../SecondaryHeading";
import { HeadingTitle } from "../../HeadingTitle";
import { RenderMarketNames } from "../../RenderComponents/RenderMarketNames";
var AmericanStyle = /** @class */ (function (_super) {
    __extends(AmericanStyle, _super);
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    function AmericanStyle(props) {
        return _super.call(this, props) || this;
    }
    AmericanStyle.prototype.renderSubheading = function () {
        return React.createElement(SecondaryHeading, { key: "subheading-" + this.props.id, cardType: this.props.cardType },
            React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }),
            this.props.marketNames.length
                ? React.createElement(RenderMarketNames, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates })
                : "");
    };
    return AmericanStyle;
}(SecondaryHeadingContent));
export { AmericanStyle };
//# sourceMappingURL=AmericanStyle.js.map